import { WebsocketStatus } from "components";
import { PATHS } from "router/paths";

import type { TFunction } from "i18next";

export const carDetailRegex = /\/cardetails\/\d+/;
export const appointmentDetailRegex = /\/appointments\/\d+/;
export const dealerDetailRegex = /\/dealers\/\d+/;
export const dealerLocationDetailRegex = /\/dealers\/locations\/\d+/;
export const leadsRegex = /leads\/?.*/;
export const warrantyRegex = /warranty\/?.*/;
export const manufacturerRegex = /manufacturer\/?.*/;
export const backordersRegex = /backorders\/?.*/;
export const devicesRegex = /devices\/?.*/;
export const newsRegex = /news\/?.*/;
export const usersRegex = /users\/?.*/;
export const customersRegex = /customers\/?.*/;
export const unlinkedExactLicensesRegex = /unlinked-exact-licenses\/?.*/;
export const dealerLicenseOverviewRegex = /dealer-license-overview\/?.*/;
export const locationLicenseOverviewRegex = /location-license-overview\/?.*/;
export const dealerDocumentationRegex = /dealer-documentation\/?.*/;
export const dmsv3SettingsRegex = /dmsv3-settings\/?.*/;
export const dmsv3CustomQueriesRegex = /dmsv3-custom-queries\/?.*/;

export const routesConfig = () => {
  return [
    {
      path: PATHS.ACCESS_KEYS_DASHBOARD,
      titleKey: "v8_access_keys",
      defaultMessage: "Claire API"
    },
    {
      path: PATHS.ACCOUNT,
      titleKey: "v8_user",
      defaultMessage: "User",
      defaultClassname: "AccountSettings-Navbar"
    },
    {
      path: PATHS.ACSES_LOGS_DASHBOARD,
      titleKey: "v8_acses_logs",
      defaultMessage: "Acses Logs"
    },
    {
      path: PATHS.AGREEMENTS_DASHBOARD,
      titleKey: "v8_agreements",
      defaultMessage: "Agreements"
    },
    {
      path: PATHS.APPOINTMENTS,
      titleKey: "v8_appointment_list",
      defaultMessage: "Appointment List",
      defaultClassname: "AppointmentList-Navbar",
      icon: <WebsocketStatus />
    },
    {
      regex: appointmentDetailRegex,
      titleKey: "v8_appointment_details",
      defaultMessage: "Appointment Details",
      defaultClassname: "AppointmentDetails-Navbar",
      icon: <WebsocketStatus />
    },
    {
      path: PATHS.BACKORDERS_DASHBOARD,
      titleKey: "v8_backorders_dashboard",
      defaultMessage: "Backorders Dashboard"
    },
    {
      path: PATHS.BRANDS_DASHBOARD,
      titleKey: "v8_brands_dashboard",
      defaultMessage: "Brands Dashboard"
    },
    {
      regex: carDetailRegex,
      titleKey: "v8_car_details",
      defaultMessage: "Car Details",
      defaultClassname: "CarDetails-Navbar",
      icon: <WebsocketStatus />
    },
    {
      path: PATHS.CHECKLIST_SETTINGS_DASHBOARD,
      titleKey: "v8_checklist_settings_dashboard",
      defaultMessage: "Checklist Settings Dashboard"
    },
    {
      path: PATHS.CHECKLISTS_DASHBOARD,
      titleKey: "v8_checklists",
      defaultMessage: "Checklists"
    },
    {
      path: PATHS.CHECK_IN_SERVICES_DASHBOARD,
      titleKey: "v8_online_check_in_services",
      defaultMessage: "Online Check-in Services"
    },
    {
      path: PATHS.COMMUNICATION_TEMPLATES,
      titleKey: "v8_communication_templates",
      defaultMessage: "Templates"
    },
    {
      path: PATHS.CUSTOMER_COM,
      titleKey: "v8_comm_settings",
      defaultMessage: "Communication Settings"
    },
    {
      path: PATHS.CUSTOMERS_DASHBOARD,
      titleKey: "v8_customers_overview",
      defaultMessage: "Customers Overview"
    },
    {
      path: PATHS.DAYPLANNER,
      titleKey: "v8_dayplanner",
      defaultMessage: "",
      defaultClassname: "Dayplanner-Navbar"
    },
    {
      path: PATHS.DEALER_DOCUMENTATION,
      titleKey: "v8_dealer_documentations",
      defaultMessage: "Dealer Documentations",
      defaultClassname: "Documentations-Navbar",
      icon: <WebsocketStatus />
    },
    {
      path: PATHS.DEALER_LICENSE_OVERVIEW,
      titleKey: "v8_dealer_licenses",
      defaultMessage: "Dealer Licenses",
      defaultClassname: "LocationLicense-Navbar"
    },
    {
      path: PATHS.DEALER_OVERVIEW_DASHBOARD,
      titleKey: "v8_dealer_overview",
      defaultMessage: "Dealer Overview"
    },
    {
      path: PATHS.DEALER_REPORTS,
      titleKey: "v8_dealer_reports",
      defaultMessage: "Dealer Reports"
    },
    {
      path: PATHS.DEALERS_DASHBOARD,
      titleKey: "v8_dealers",
      defaultMessage: "Dealers"
    },
    {
      path: PATHS.DEALERS_DASHBOARD_DEALER,
      regex: dealerDetailRegex,
      titleKey: "v8_edit_dealer",
      defaultMessage: "Edit Dealer"
    },
    {
      path: PATHS.DEALERS_DASHBOARD_LOCATION,
      regex: dealerLocationDetailRegex,
      titleKey: "v8_edit_location",
      defaultMessage: "Edit Location"
    },
    {
      path: PATHS.DEVICES_DASHBOARD,
      titleKey: "v8_tablets",
      defaultMessage: "Tablets"
    },
    {
      path: PATHS.DMS_CAPABILITIES_DASHBOARD,
      titleKey: "v8_dms_list",
      defaultMessage: "DMS List"
    },
    {
      path: PATHS.DMSV3_CUSTOM_QUERIES,
      titleKey: "v8_dms_custom_queries",
      defaultMessage: "Custom Queries"
    },
    {
      path: PATHS.DMSV3_SETTINGS,
      titleKey: "v8_dms_settings",
      defaultMessage: "DMS Settings"
    },
    {
      path: PATHS.DMSv3_MONITORING_DASHBOARD,
      titleKey: "v8_dms_monitoring",
      defaultMessage: "DMS Monitoring"
    },
    {
      path: PATHS.DPO_CONTRACT,
      titleKey: "v8_dpo_contract",
      defaultMessage: "DPO Contract"
    },
    {
      path: PATHS.EXACT_MONITORING,
      titleKey: "v8_exact_monitoring",
      defaultMessage: "Exact Monitoring"
    },
    {
      path: PATHS.FACTORY_EXPORTS_DASHBOARD,
      titleKey: "v8_factory_exports",
      defaultMessage: "Factory Exports"
    },
    {
      path: PATHS.HOLDINGS_DASHBOARD,
      titleKey: "v8_holding",
      defaultMessage: "Holding"
    },
    {
      path: PATHS.INCOMPLETE_TYRES_DASHBOARD,
      titleKey: "v8_incomplete_tyres",
      defaultMessage: "Incomplete Tyres"
    },
    {
      path: PATHS.KEYLOCKERS_DASHBOARD,
      titleKey: "v8_key_lockers",
      defaultMessage: "Key Lockers"
    },
    {
      path: PATHS.LEADS_DASHBOARD,
      titleKey: "v8_leads",
      defaultMessage: "Leads",
      defaultClassname: "Leads-Navbar"
    },
    {
      path: PATHS.KIOSK_DASHBOARD,
      titleKey: "v8_kiosk",
      defaultMessage: "Kiosk"
    },
    {
      path: PATHS.LOCATION_LICENSE_OVERVIEW,
      titleKey: "v8_location_licenses",
      defaultMessage: "Location Licenses",
      defaultClassname: "LocationLicense-Navbar"
    },
    {
      path: PATHS.LOCATION_OVERVIEW_DASHBOARD,
      titleKey: "v8_location_overview",
      defaultMessage: "Location Overview"
    },
    {
      path: PATHS.LOCATION_REPORTS,
      titleKey: "v8_location_reports",
      defaultMessage: "Location Reports"
    },
    {
      path: PATHS.MANUFACTURER_DASHBOARD,
      titleKey: "v8_manufacturer_dashboard",
      defaultMessage: "Manufacturer Dashboard",
      defaultClassname: "manufacturer-Navbar",
      icon: <WebsocketStatus />
    },
    {
      path: PATHS.NOTES_MENU,
      titleKey: "v8_notes_menu",
      defaultMessage: "Notes",
      defaultClassname: "Notes-Navbar"
    },
    {
      path: PATHS.NEWS_DASHBOARD,
      titleKey: "v8_news",
      defaultMessage: "News",
      defaultClassname: "News-Navbar"
    },
    {
      path: PATHS.PARKING_GATE_CODES_DASHBOARD,
      titleKey: "v8_parking_gate_codes",
      defaultMessage: "Pending Gate Codes"
    },
    {
      path: PATHS.PENDING_CHECKLISTS_DASHBOARD,
      titleKey: "v8_pending_checklists",
      defaultMessage: "Pending Checklists"
    },
    {
      path: PATHS.PRIVACY_AND_SECURITY_DASHBOARD,
      titleKey: "v8_privacy_and_security",
      defaultMessage: "Privacy and Security"
    },
    {
      path: PATHS.QUESTIONS_DASHBOARD,
      titleKey: "v8_questions",
      defaultMessage: "Questions"
    },
    {
      path: PATHS.REPORT_TEMPLATES_DASHBOARD,
      titleKey: "v8_report_templates",
      defaultMessage: "Report Templates"
    },
    {
      path: PATHS.SHAREBOX_DASHBOARD,
      titleKey: "v8_sharebox_dashboard",
      defaultMessage: "Sharebox Dashboard"
    },
    {
      path: PATHS.STATUS_LIST_DASHBOARD,
      titleKey: "v8_status_list",
      defaultMessage: "Status List"
    },
    {
      path: PATHS.STYLE_GUIDE,
      titleKey: "v8_claire_v8",
      defaultMessage: "Claire V8",
      defaultClassname: "Styleguide-Navbar"
    },
    {
      path: PATHS.TAGS_DASHBOARD,
      titleKey: "v8_tags",
      defaultMessage: "Tags"
    },
    {
      path: PATHS.THREE_DEPARTMENT_DASHBOARD,
      titleKey: "v8_three_department_dashboard",
      defaultMessage: "Three Department Dashboard"
    },
    {
      path: PATHS.TYRE_DISCOUNTS_DASHBOARD,
      titleKey: "v8_tyre_discounts",
      defaultMessage: "Tire Discounts"
    },
    {
      path: PATHS.TYRES_DASHBOARD,
      titleKey: "v8_tyres",
      defaultMessage: "Tyres"
    },
    {
      path: PATHS.UNLINKED_EXACT_LICENSES,
      titleKey: "v8_unlinked_exact_licenses",
      defaultMessage: "Unlinked Exact Licenses"
    },
    {
      path: PATHS.USERS,
      titleKey: "v8_users",
      defaultMessage: "Users"
    },
    {
      path: PATHS.WARRANTY_DASHBOARD,
      titleKey: "v8_warranty_dashboard",
      defaultMessage: "Warranty Dashboard",
      icon: <WebsocketStatus />
    },
    {
      path: PATHS.WEBHOOKS_DASHBOARD,
      titleKey: "v8_webhooks",
      defaultMessage: "Webhooks"
    }
  ];
};

export const getRouteProperties = (t: TFunction, location: any) => {
  for (const { path, regex, titleKey, defaultMessage, defaultClassname, icon } of routesConfig()) {
    if (location.pathname === path || (regex && regex.test(location.pathname))) {
      return {
        title: (
          <>
            {defaultMessage && <h4>{t(titleKey) || defaultMessage}</h4>}
            {icon}
          </>
        ),
        defaultClassname: defaultClassname
      };
    }
  }

  return {
    title: <h4>Claire V8</h4>,
    defaultClassname: "ClaireV8"
  };
};
